
import NewComponent from "../../../components/gift_records/New.vue";

export default {
  components: {
    NewComponent
  }
};
